;
define("global_views_pagination.tpl", function(){});

